/* eslint id-length: [2, {"exceptions":["a","b"]}] */

/**
 * Text columns are easy, just push N/A data to the bottom
 */
import { buildRowProperties, sortArbitrary } from './util';
import mixedSort from './mixedSort';
import { appDefault as constants } from './../../config/config';

export default function textSorter(
  a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
  const aProps = buildRowProperties(a, column, constants);
  const bProps = buildRowProperties(b, column, constants);

  // NAs pushed to the bottom
  if (aProps.naData && bProps.naData) {
    const sorted = sortArbitrary(
      aProps.value,
      bProps.value,
      constants.dataNotAvailable,
      isInverted
    );
    if (sorted) {
      return sorted;
    }
  } else if (aProps.naData) {
    return (isInverted ? -1 : 1);
  } else if (bProps.naData) {
    return (isInverted ? 1 : -1);
  }

  if (!a.localeCompare || !b.localeCompare || a === b) {
    return mixedSort(a, b, column, isInverted, aBase, bBase);
  }

  // Summary rows float up without matching groups
  if (a === b && aIsSummary) {
    return (isInverted ? -1 : 1) * -1;
  } else if (a === b && bIsSummary) {
    return (isInverted ? 1 : -1) * -1;
  } else if (a === b) {
    return a.localeCompare(b);
  }

  // Umm, and if there is an arbitrary display order, sort that way
  if ((column.sortOrder ||  []).length) {
    const sorted = sortArbitrary(
      a,
      b,
      column.sortOrder
    );
    if (sorted) {
      return (isInverted ? -1 : 1) * sorted;
    }
  }

  if (a === b && aBase !== undefined && bBase !== undefined) {
    return aBase.localeCompare(bBase);
  }

  return a.localeCompare(b);
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/sorters/textSort.js